import { lazy, memo } from 'react'
import { SchoolModalKey } from '../../../redux/schoolModalSlice'
import { v4 } from 'uuid'

const AllBookableTeachersModal = lazy(() =>
    import('../schools/components/AllBookableTeachersModal').then((m) => ({
        default: m.default,
    }))
)
const BookableTeachersModal = lazy(() =>
    import('../schools/components/BookableTeachersModal').then((m) => ({
        default: m.default,
    }))
)
const SendRequestModal = lazy(() =>
    import('../schools/components/SendRequestModal').then((m) => ({
        default: m.default,
    }))
)
const CreateBookingsModal = lazy(() =>
    import('../schools/components/CreateBookingsModal').then((m) => ({
        default: m.default,
    }))
)
const CancelBookingModal = lazy(() =>
    import('../schools/components/CancelBookingModal').then((m) => ({
        default: m.default,
    }))
)
const BookingDetailModal = lazy(() =>
    import('../schools/components/BookingDetailModal').then((m) => ({
        default: m.default,
    }))
)
const ReportIncidentModal = lazy(() =>
    import('../schools/components/ReportIncidentModal').then((m) => ({
        default: m.default,
    }))
)
const ReportIssueModal = lazy(() =>
    import('../schools/components/ReportIssueModal').then((m) => ({
        default: m.default,
    }))
)
const CancelPendingSearchModal = lazy(() =>
    import('../schools/components/CancelPendingSearchModal').then((m) => ({
        default: m.default,
    }))
)

const modalComponentList: React.LazyExoticComponent<
    React.ComponentType<any>
>[] = [
    AllBookableTeachersModal,
    BookableTeachersModal,
    SendRequestModal,
    CreateBookingsModal,
    CancelBookingModal,
    BookingDetailModal,
    ReportIncidentModal,
    ReportIssueModal,
    // TeacherProfileModal,
    CancelPendingSearchModal,
]

const modalComponentMap: Record<
    SchoolModalKey,
    React.LazyExoticComponent<React.ComponentType<any>>
> = {
    allBookableTeachers: AllBookableTeachersModal,
    bookableTeachers: BookableTeachersModal,
    sendRequests: SendRequestModal,
    createBooking: CreateBookingsModal,
    cancelBooking: CancelBookingModal,
    bookingDetails: BookingDetailModal,
    reportIncident: ReportIncidentModal,
    reportIssue: ReportIssueModal,
    // teacherProfile: TeacherProfileModal,
    cancelPendingReplacement: CancelPendingSearchModal,
}

// const modalKeys = Object.keys(SchoolModalKeys) as SchoolModalKey[]
const SchoolModals = () => {
    // console.log('school modals rendered')
    // const dispatch = useDispatch()
    // const modalStack = useSelector(selectSchoolModalStack)
    // const timeoutsRef = useRef<Record<string, ReturnType<typeof setTimeout>>>({})

    // useEffect(() => {
    //     if (Object.keys(modalStack).length === 0) {
    //         Object.values(timeoutsRef.current).forEach((timeout) =>
    //             clearTimeout(timeout)
    //         )
    //         timeoutsRef.current = {}
    //         return
    //     }
    //     Object.entries(modalStack).forEach(([key, entry]) => {
    //         if (!entry || entry.open) {
    //             if (timeoutsRef.current[key]) {
    //                 clearTimeout(timeoutsRef.current[key])
    //                 delete timeoutsRef.current[key]
    //             }
    //             return
    //         }

    //         if (!timeoutsRef.current[key]) {
    //             timeoutsRef.current[key] = setTimeout(() => {
    //                 dispatch(removeModal(key as SchoolModalKey))
    //                 delete timeoutsRef.current[key]
    //             }, 300)
    //         }
    //     })
    // }, [dispatch, modalStack])

    return modalComponentList.map((Component) => <Component key={v4()} />)
}

// const ModalRenderer = memo(({ modalKey }: { modalKey: SchoolModalKey }) => {
//     const modalEntry = useSelector(selectModalEntry(modalKey))

//     if (!modalEntry) return null

//     const Component = modalComponentMap[modalKey]
//     return (
//         <Suspense fallback={null}>
//             <Component {...(modalEntry as any)} />
//         </Suspense>
//     )
// })

export default memo(SchoolModals)
